export const categoriesPagePath = "/category"